// @flow
import {unsafelyParseMarkdown, Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

function mapItems(list, config) {
  return list.map((el) => {
    return {
      name: el.name,
      documentation: unsafelyParseMarkdown(el.documentation, config),
    };
  });
}

export const ErrorCodes: MarkdocTagRegistration = {
  tag: 'error-codes',
  children: [],
  component: 'ErrorCodes',
  attributes: {
    codesList: {
      type: Array,
      required: true,
      description: 'List of error codes objects',
    },
  },
  description: 'Table of error codes for the /docs/error-codes page',
  render(node, config) {
    const children = node.renderChildren(config);
    const attributes = node.renderAttributes(this.attributes, config);

    if (attributes.codesList) {
      return new Tag(
        this.tag,
        {
          ...attributes,
          codesList: mapItems(attributes.codesList, config),
        },
        children,
      );
    }

    return new Tag(this.tag, attributes, children);
  },
};
